// extracted by mini-css-extract-plugin
module.exports = {"ShoppingGuideImagewrapper":"ShoppingGuideImage_ShoppingGuideImagewrapper__X929b"};